(function() {
'use strict';

    angular.module( APP_ID )

        .filter( 'stripHtmlTags', stripHtmlTags )
        .filter( 'safeHtml', [ '$sce', markAsHtmlSafe ])
        .filter( 'safeUrl', [ '$sce', markAsUrlSafe ])
        .filter( 'sortObjectBy', sortObjectBy )
        .filter( 'wrapNewlines', wrapNewLines )
        .filter( 'entitiesToCharacters', entitiesToCharacters )
        .filter( 'encodeUri', encodeUri )
        .filter( 'contains', containsString )
        .filter( 'prepend', prependString )
        .filter( 'append', appendString );





    /* ===== FILTERS DEFINITIONS ============================================ */


    function stripHtmlTags() {
        var TAG_BODY_TEMPLATE = '(?:[^"\'>]|"[^"]*"|\'[^\']*\')*';

        var TAG_OR_COMMENT_REGEXP = new RegExp(
            '<(?:'
            // Comment body.
            + '!--(?:(?:-*[^->])*--+|-?)'
            // Special "raw text" elements whose content should be elided.
            + '|script\\b' + TAG_BODY_TEMPLATE + '>[\\s\\S]*?</script\\s*'
            + '|style\\b' + TAG_BODY_TEMPLATE + '>[\\s\\S]*?</style\\s*'
            // Regular name
            + '|/?[a-z]'
            + TAG_BODY_TEMPLATE
            + ')>',
            'gi');

        return function( html ) {
            var oldHtml;
            do {
                oldHtml = html;
                html = html.replace( TAG_OR_COMMENT_REGEXP, '' );
            } while (html !== oldHtml);
            return html.replace( /</g, '&lt;' );
        }
    }


    /**
     * Makes a HTML code safe before appending it to ng-bind-html directive.
     *
     * @param {angular.ISCEService} $sce
     */
    function markAsHtmlSafe( $sce ){
        return $sce.trustAsHtml;
    }


    function markAsUrlSafe( $sce ){
        return function( url ) {
            return $sce.trustAsResourceUrl( url );
        }
    }


    /**
     * Transforms HTML entities inside plain text into standard Unicode symbols.\
     *
     * Symbols supported: '&'
     */
    function entitiesToCharacters(){
        return function( input ){
            return input ? input.replace( /&amp;/, '&' ) : '';
        }
    }


    /**
     * If a newline character (`\n`) is found in the source content, it gets replaced
     * by ending and starting tag of supplied wrapping HTML element (<p> by default).
     *
     * With that said, it is important to wrap the expression that's being evaluated into
     * the same HTML tag to match correct pairing (eg. <p>{{ expression | wrapNewlines:p }}</p>).
     */
    function wrapNewLines() {
        var NEWLINE_REGEX    = /\n/g,
        HTML_ADDED_ATTRIBUTE = "data-html-added";

        return function( content, wrappingElement ) {
            var wrappingElement = wrappingElement || 'p';

            return content.replace( NEWLINE_REGEX, '</' + wrappingElement + '><' + wrappingElement + ' ' + HTML_ADDED_ATTRIBUTE + '>');
        }
    }


    /**
     * Sorts object's attributes as they were a standard array
     * (useful for `ng-repeat` or `ng-options` directives).
     */
    function sortObjectBy() {
        return function( input, attribute ) {
            if ( !angular.isObject( input ) ) return input;

            var array = [];

            for( var objectKey in input ) {
                // Exclude non-objects and Angular's helpers
                if ( angular.isObject(input[objectKey]) && objectKey.charAt(0) !== "$" ) {
                    array.push( input[ objectKey ]);
                }
            }

            array.sort(function( a, b ){
                var alc = a[attribute].toLowerCase(),
                    blc = b[attribute].toLowerCase();
                return alc > blc ? 1 : alc < blc ? -1 : 0;
            });

            return array;
        }
    }


    /**
     * Turns given string into safe URI.
     */
    function encodeUri() {
        return function( input ) {
            if( input ) {
                return window.encodeURIComponent( input ); /* eslint angular/window-service: 0 */
            }
            return "";
        }
    }


    /**
     * Adds string BEFORE the input, if input is not null.
     */
    function prependString() {
        return function( input, stringToPrepend ) {

            if ( input ) {
                return stringToPrepend + input;
            }

            return '';
        }
    }


    /**
     * Adds string AFTER the input, if input is not null.
     */
    function appendString() {
        return function( input, stringToPrepend ) {

            if ( input ) {
                return input + stringToPrepend;
            }

            return '';
        }
    }


    /**
     * Adds string AFTER the input, if input is not null.
     */
    function containsString() {
        return function( input, stringToCheck ) {
            return input.indexOf( stringToCheck ) > -1;
        }
    }


})();
